import { ElevatorUsage } from "../generated/usage/elevator-usage";
import { EscalatorUsage } from "../generated/usage/escalator-usage";
import { EscalatorControl } from "../generated/control/escalator-control";
import { DeviceDirection } from "../../types/DeviceDirection";

const DIRECTION_DISPLAY: Partial<Record<number, string>> = {
  [ElevatorUsage.Up]: "Up",
  [ElevatorUsage.Down]: "Down",
  [ElevatorUsage.Forward]: "Forward",
  [ElevatorUsage.Backward]: "Backward",
  [ElevatorUsage.RunUp]: "Run Up",
  [ElevatorUsage.RunDown]: "Run Down",
  [ElevatorUsage.Moving]: "Moving",
  [EscalatorUsage.Up]: "Up",
  [EscalatorUsage.Down]: "Down",
};

export function directionDisplayName(d: DeviceDirection): string {
  if (d === null) return "Idle";
  return DIRECTION_DISPLAY[d] ?? "Unknown";
}

const DOOR_ZONE_DISPLAY: Partial<Record<ElevatorUsage, string>> = {
  [ElevatorUsage.AboveDoorZone]: "Above Door Zone",
  [ElevatorUsage.InDoorZone]: "In Door Zone",
  [ElevatorUsage.BelowDoorZone]: "Below Door Zone",
};

export function doorZoneDisplayName(code: ElevatorUsage | null): string {
  if (code === null) return "";
  return DOOR_ZONE_DISPLAY[code] ?? `Unknown (${code})`;
}

const ESCALATOR_CONTROL_DISPLAY: Record<EscalatorControl, string> = {
  [EscalatorControl.RunUp]: "Run Up",
  [EscalatorControl.RunDown]: "Run Down",
  [EscalatorControl.Stop]: "Stop",
};

export function escalatorControlDisplayName(
  code: EscalatorControl | null
): string {
  if (code === null) return "";
  return ESCALATOR_CONTROL_DISPLAY[code] ?? `Unknown (${code})`;
}

export function directionStringToEnum(s: string): DeviceDirection {
  switch (s) {
    case "Up":
      return ElevatorUsage.Up;
    case "Down":
      return ElevatorUsage.Down;
    case "Forward":
      return ElevatorUsage.Forward;
    case "Backward":
      return ElevatorUsage.Backward;
    case "Idle":
      return null;
    default:
      return null;
  }
}

export function doorZoneStringToEnum(s: string): ElevatorUsage | null {
  switch (s) {
    case "AboveDoorZone":
      return ElevatorUsage.AboveDoorZone;
    case "InDoorZone":
      return ElevatorUsage.InDoorZone;
    case "BelowDoorZone":
      return ElevatorUsage.BelowDoorZone;
    default:
      return null;
  }
}

export function escControlStringToEnum(s: string): EscalatorControl | null {
  switch (s) {
    case "RunUp":
      return EscalatorControl.RunUp;
    case "RunDown":
      return EscalatorControl.RunDown;
    case "Stop":
      return EscalatorControl.Stop;
    default:
      return null;
  }
}
